import ScrollMagic from 'scrollmagic'
import {
  TweenMax,
  TimelineMax,
} from 'gsap'
import {ScrollMagicPluginGsap} from 'scrollmagic-plugin-gsap'
import AOS from 'aos'
import Swiper, {Navigation, Pagination} from 'swiper'
import imagesLoaded from 'imagesloaded'
import Packery from 'packery'
import axios from 'axios'

ScrollMagicPluginGsap(ScrollMagic, TweenMax, TimelineMax);

export default {
  init() {
    if (!$('body').hasClass('page-template-template-home-v2')) {
      this.hideLogoOnScroll()
      this.cover()
      this.navToggle()
    }
    this.accordion()
    this.videoCover()
    this.imageSlider()
    this.logoSlider()
    this.masonryGrid()
    this.newsletterSignup()
  },
  cover() {
    if ($('.site-cover').length) {
      const controller = new ScrollMagic.Controller({loglevel: 0})

      new ScrollMagic.Scene({
        tweenChanges: true,
        triggerElement: '.site-cover',
        duration: $(window).height() * 1.5,
        offset: 0,
      }).setTween(TweenMax.fromTo('.site-wrapper', 1,
        {y: -($(window).height() * 2)}, {y: 0}
      )).on('enter', () => {
        $('.site-header').removeClass('site-header--blend')
      }).on('leave', () => {
        $('.site-header').addClass('site-header--blend')
      }).addTo(controller)

      $(document).on('click', '.site-cover button', (e) => {
        e.preventDefault()

        $('html, body').scrollTop($(window).height())
      })
    } else {
      if (!$('body').hasClass('page-template-template-home-v2')) {
        $('.site-header').addClass('site-header--blend')
      }
    }
  },
  hideLogoOnScroll() {
    this.handleHideLogoOnScroll()

    window.addEventListener('scroll', this.handleHideLogoOnScroll, {passive: true})
  },
  handleHideLogoOnScroll() {
    const currentScrollTop = $(window).scrollTop()

    if (currentScrollTop < 100 || currentScrollTop >= ($('.site-footer').offset().top + ($('.site-footer__sign-up').height() - 200))) {
      $('.site-header').removeClass('site-header--out')
      return
    }


    $('.site-header').addClass('site-header--out')
  },
  navToggle() {
    $(document).on('click', '.site-header__toggle', (e) => {
      e.preventDefault()
      $('body').toggleClass('nav-open')
    })
  },
  accordion() {
    if (!$('.accordion').length) {
      return
    }

    $(document).on('click', '.accordion__item__title', function (e) {
      e.preventDefault()

      let $item = $(this).parent()
      if ($item.hasClass('accordion__item--expanded')) {
        $item.removeClass('accordion__item--expanded')
        $item.find('.accordion__item__detail').height(0)
        $(this).attr('aria-expanded', false)
      } else {
        $item.addClass('accordion__item--expanded')
        $item.find('.accordion__item__detail').height($item.find('.accordion__item__detail__inside').outerHeight())
        $(this).attr('aria-expanded', true)
      }

    })
  },
  videoCover() {
    if (!$('.video-cover').length) {
      return
    }

    $(document).on('click', '.video-cover button', function (e) {
      e.preventDefault()

      let $videoCover = $(this).parent()

      $videoCover.addClass('video-cover--playing')

      $videoCover.find('video').get(0).play()
    })

  },
  imageSlider() {
    if (!$('.image-slider').length) {
      return
    }

    Swiper.use([Navigation, Pagination]);
    $('.image-slider').each(function () {
      new Swiper($(this).get(0), {
        slidesPerView: 1,
        speed: 400,
        pagination: {
          el: $(this).find('.swiper-pagination').get(0),
          type: 'bullets',
        },
        navigation: {
          nextEl: $(this).find('.swiper-button-next').get(0),
          prevEl: $(this).find('.swiper-button-prev').get(0),
        },
        loop: true,
      })
    })

  },
  logoSlider() {
    if (!$('.logo-slider').length) {
      return
    }

    Swiper.use([Navigation, Pagination]);

    new Swiper('.logo-slider', {
      slidesPerView: 'auto',
      speed: 400,
      pagination: {
        el: '.swiper-pagination',
        type: 'bullets',
      },
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      loop: true,
    });

  },
  masonryGrid() {
    if (!$('.grid').length) {
      return
    }

    const grid = new Packery('.grid', {
      gutter: 0,
      itemSelector: '.grid__item',
      percentPosition: true,
    })
    new imagesLoaded('.grid', () => {
      grid.layout()
    })


    $(document).on('click', '.btn-load', function (e) {
      e.preventDefault()

      if ($(this).hasClass('busy')) {
        return
      }

      $(this).addClass('busy')

      let page = $(this).data('page')
      page++
      axios.get(`/wp-json/outland/v1/masonry?_taxonomy=${$(this).data('taxonomy')}&_term=${$(this).data('term')}&_page=${page}&_posts-per-page=${$(this).data('posts-per-page')}&author=${$(this).data('author')}`)
        .then((response) => {
          $('#masonry-grid').append(response.data.result)
          grid.appended($('#masonry-grid').find('.fresh'))
          $('#masonry-grid').find('.fresh').removeClass('fresh')
          $(this).data('page', page)
          new imagesLoaded('.grid', () => {
            grid.layout()
          })
          if (page >= response.data.max_pages) {
            $(this).hide()
          }
          $(this).removeClass('busy')
        })
        .catch(() => {
          console.log(e)
          $(this).removeClass('busy')

        })
    });
  },
  newsletterSignup() {
    $(document).on('submit', '#newsletter-signup', (e) => {
      e.preventDefault()

      if ($('#newsletter-signup').hasClass('busy')) {
        return
      }

      $('#newsletter-signup').addClass('busy')

      axios.post('/wp-json/outland/v1/newsletter-subscribe', {email: $('#newsletter_email').val()})
        .then((response) => {
          $('#newsletter-signup').removeClass('error')

          if (!response.data) {
            $('#newsletter-signup').addClass('error').removeClass('busy')

            return
          }

          if (!response.data.subscribed) {
            $('#newsletter-signup').addClass('error').removeClass('busy')

            return
          }

          $('#newsletter-signup').hide()
          $('#newsletter-signup-confirmation').show()
        })
        .catch(() => {

          $('#newsletter-signup').addClass('error').removeClass('busy')

        })
    })
  },
  finalize() {
    AOS.init();
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/common.js